import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=057df55c&scoped=true&"
import script from "./Autocomplete.vue?vue&type=script&lang=js&"
export * from "./Autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./Autocomplete.vue?vue&type=style&index=0&id=057df55c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057df55c",
  null
  
)

export default component.exports